import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('Slide', null, { withChildren: true });
